export const environment = {
  production: false,
  apiUrl: 'https://devapi.supergarzon.com/api',
  apiSecret: 'm0neder0G4rzon*#'
};
